export default [
  {
    position: "absolute",
    top: 0.8,
    left: 25,
    class: "tooltips",
    tooltipClass: "right",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "compensationPlanningP2.ttTextOne",
    hover: false,
    id: "SP_Compensation_Navigation_Home",
    index: 0,
  },
  {
    position: "absolute",
    top: 21.5,
    left: 22,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "compensationPlanningP2.mTitleTwo",
    mBody: "compensationPlanningP2.mBodyTwo",
    isVideo: true,
    videoThumb: "SP-Compensation-Planning-Thumb",
    videoURL: "SP-Compensation-Planning.mp4",
    vidIcon: true,
    id: "SP_Compensation_Video_Planning",
    index: 1,
  },
  {
    position: "absolute",
    top: 44,
    left: 60,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "compensationPlanningP2.mTitleOne",
    mBody: "compensationPlanningP2.mBodyOne",
    id: "SP_Compensation_Info_Objectives",
    infoIcon: true,
    isAction: false,
    index: 2,
  },
];
